import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/noviceGuide/line.png'


const _withScopeId = n => (_pushScopeId("data-v-f3222964"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "novice-guide-index"
}
const _hoisted_2 = { class: "novice-guide-bg" }
const _hoisted_3 = { class: "novice-guide-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "novice-guide-right" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "novice-guide-bottom" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "novice-guide-confirm-btn" }
const _hoisted_11 = { class: "step" }

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import type { BGL } from './data'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    default: ''
  },
  // 父组件控制是否展示
  show: {
    type: Boolean,
    default: true
  },
  list: {
    type: Array,
    default: () => []
  }
},
  emits: ['next', 'return', 'show'],
  setup(__props, { expose, emit }) {

const props = __props
const store = useStore()



const gudieList = computed(() => {
  return props.list
})
const index = ref(0)
const guideItem: any = computed(() => {
  return props.list[index.value]
})
const returnFn = () => {
  emit('return')
  close()
}
const next = () => {
  console.log(props.list.length - 1, index.value)
  if (props.list.length - 1 === index.value) {
    close()
    emit('return')
    return
  }
  index.value++
  emit('next', index.value)
}
expose({
  open
})
const isFinish = ref(false)
const showGuide: any = computed(() => {
  if (!store.state.guide.guideState[props.name] && isFinish.value) {
    emit('show', true, index.value)
  }
  return !store.state.guide.guideState[props.name]
})
store.dispatch('guide/getGuide', { customerId: store.getters.user?.customerId }).then(() => {
  isFinish.value = true
})
const close = () => {
  // isFinish.value = false
  store.dispatch('guide/changeGuideStatus', { key: props.name, value: true })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_unref(showGuide) && isFinish.value && __props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "novice-guide-top",
            style: _normalizeStyle({ height: _unref(guideItem).startTop + 'px' })
          }, null, 4),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "novice-guide-left",
              style: _normalizeStyle({ width: _unref(guideItem).startLeft + 'px', height: _unref(guideItem).boxHeight + 'px' })
            }, null, 4),
            _createElementVNode("div", {
              class: "novice-guide-middle",
              style: _normalizeStyle({ width: _unref(guideItem).boxWidth + 'px', height: _unref(guideItem).boxHeight + 'px' })
            }, [
              _createElementVNode("div", {
                class: "novice-guide-radio-left-top",
                style: _normalizeStyle({ 'background-image': `radial-gradient(circle ${_unref(guideItem).boxRadio}px at ${_unref(guideItem).boxRadio}px 100%,  transparent ${_unref(guideItem).boxRadio}px, rgba(0, 0, 0, 0.6) 103%)`, width: _unref(guideItem).boxRadio + 'px', height: _unref(guideItem).boxRadio + 'px' })
              }, null, 4),
              _createElementVNode("div", {
                class: "novice-guide-radio-right-top",
                style: _normalizeStyle({ 'background-image': `radial-gradient(circle ${_unref(guideItem).boxRadio}px at 0 100%,  transparent ${_unref(guideItem).boxRadio}px, rgba(0, 0, 0, 0.6) 103%)`, width: _unref(guideItem).boxRadio + 'px', height: _unref(guideItem).boxRadio + 'px' })
              }, null, 4),
              _createElementVNode("div", {
                class: "novice-guide-radio-left-bottom",
                style: _normalizeStyle({ 'background-image': `radial-gradient(circle ${_unref(guideItem).boxRadio}px at ${_unref(guideItem).boxRadio}px 0%,  transparent ${_unref(guideItem).boxRadio}px, rgba(0, 0, 0, 0.6) 103%)`, width: _unref(guideItem).boxRadio + 'px', height: _unref(guideItem).boxRadio + 'px' })
              }, null, 4),
              _createElementVNode("div", {
                class: "novice-guide-radio-right-bottom",
                style: _normalizeStyle({ 'background-image': `radial-gradient(circle ${_unref(guideItem).boxRadio}px at 0 0%,  transparent ${_unref(guideItem).boxRadio}px, rgba(0, 0, 0, 0.6) 103%)`, width: _unref(guideItem).boxRadio + 'px', height: _unref(guideItem).boxRadio + 'px' })
              }, null, 4)
            ], 4),
            _hoisted_4
          ]),
          _hoisted_5
        ]),
        _createElementVNode("div", {
          class: "novice-guide-line",
          style: _normalizeStyle({ top: _unref(guideItem).lineTop + 'px', left: _unref(guideItem).lineLeft + 'px',transform: `rotate(${_unref(guideItem).lineRotate}deg)` })
        }, _hoisted_7, 4),
        _createElementVNode("div", {
          class: "novice-guide-confirm",
          style: _normalizeStyle({ top: _unref(guideItem).dialogTop + 'px', left: _unref(guideItem).dialogLeft + 'px' })
        }, [
          _createElementVNode("div", {
            class: "novice-guide-confirm-title",
            innerHTML: _unref(guideItem).title
          }, null, 8, _hoisted_8),
          _createElementVNode("div", {
            class: "novice-guide-confirm-text",
            innerHTML: _unref(guideItem).text
          }, null, 8, _hoisted_9),
          _createElementVNode("div", _hoisted_10, [
            (_unref(guideItem).isReturn)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "return-btn",
                  onClick: returnFn
                }, _toDisplayString(_unref(t)('跳过')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_11, "(" + _toDisplayString(index.value+1) + "/" + _toDisplayString(_unref(gudieList).length) + ")", 1),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "next-btn",
              onClick: next
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(gudieList).length !== index.value + 1 ? _unref(t)('下一步') : _unref(t)('我知道了')), 1)
              ]),
              _: 1
            })
          ])
        ], 4)
      ]))
    : _createCommentVNode("", true)
}
}

})